
import React from 'react'

export const Loading: React.FC = () => (
   <div className="loading">  <div></div><div></div><div></div><div></div>  </div>
)